import { render, staticRenderFns } from "./AddLearningHub.vue?vue&type=template&id=214f0207"
import script from "./AddLearningHub.vue?vue&type=script&lang=js"
export * from "./AddLearningHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports